import RightSide from './RightSide';

export default RightSide;
